import { KEY_CODES } from 'consts/consts';
import { BUTTON_TYPE, FONT_SIZE } from 'consts/enum';
import { LS } from 'consts/localStorage';
import { addClass, getFontSetting, removeClass, writeToLs } from 'helpers/helpers';
import { botAvatar } from 'icons/botAvatar';
import { ENGT_CHAT } from 'js/bot.model';
import { Button } from 'ui/button/button.module';
import { fontSettingsOption } from './fontSettings.model';
import { FontSettingsTemplate } from './fontSettings.template';

export class FontSettings {
	constructor(props) {
		this.init(props);
		this.initWrapper();
		this.initComponents();
	}

	init(props) {
		this.data = {
			...fontSettingsOption,
			subtitle: ENGT_CHAT.get('GENERIC_STRINGS')?.['SELECT_FONT'] || 'Select a font size for your bot:',
		};
		this.setter(props);
	}

	initWrapper() {
		const wrapper = document.createElement('div');
		wrapper.id = 'engtFontSettings';
		wrapper.classList.add('engt-font-settings');
		wrapper.innerHTML = FontSettingsTemplate(this.data);

		this.html = wrapper;
	}

	initComponents() {
		const ref = this;
		const { settings, defaultMsg } = this.data;
		const options = this.html.querySelector('.engt-font-settings-options');
		const preferredFontSettings = getFontSetting();
		const defaultSize = window.innerWidth < 460 ? 'sm' : 'md';

		const confirmBtn = new Button({
			type: BUTTON_TYPE.PRIMARY,
			label: ENGT_CHAT.get('GENERIC_STRINGS')?.CONFIRM || 'Confirm',
			onClick() {
				const root = document.documentElement;
				const isBotImageAvailable = !!ENGT_CHAT.get('config.chat_header_icon_url');
				const currentFontSize = getFontSetting();
				const updatedFontSize = ref.html
					.querySelector('.engt-font-settings-options')
					.getAttribute('data-selected');

				if (updatedFontSize === FONT_SIZE.SMALL) {
					root.style.setProperty('--engt-launch-screen-header', isBotImageAvailable ? '21.5em' : '16.5em');
				} else {
					root.style.setProperty('--engt-launch-screen-header', isBotImageAvailable ? '20em' : '16em');
				}

				removeClass(document.querySelector('.engt'), `engt-font-${currentFontSize}`);
				addClass(document.querySelector('.engt'), `engt-font-${updatedFontSize}`);
				writeToLs(LS().FONT_SETTING, updatedFontSize);
				ENGT_CHAT.get('hideChatSettingsScreen')();
			},
			radius: 18,
		}).render();

		const onOptionClick = function (e, isTriggeredByEnter) {
			if (e.target.className.indexOf('option-name') > -1 || isTriggeredByEnter) {
				const parent = this.parentNode;
				const selectedId = this.getAttribute?.('data-id');

				parent.setAttribute('data-selected', selectedId);
				for (let i = 0; i < parent?.children?.length; i++) {
					if (parent.children[i].getAttribute('data-id') === selectedId) {
						parent.children[i].setAttribute('data-active', true);
					} else {
						parent.children[i].setAttribute('data-active', false);
					}
				}
			}
		};

		for (let i = 0; i < settings.length; i++) {
			const avatar = document.createElement('div');
			const optionLabel = ENGT_CHAT.get('GENERIC_STRINGS')?.[`${settings[i].localisedId}`] || settings[i].label;
			const defaultFontLabel = ENGT_CHAT.get('GENERIC_STRINGS')?.['DEFAULT_FONT']
				? ` (${ENGT_CHAT.get('GENERIC_STRINGS')?.['DEFAULT_FONT']})`
				: defaultMsg;
			avatar.style.height = '36px';
			avatar.style.width = '36px';
			avatar.innerHTML = botAvatar();
			const childOption = options.children[i];
			const fontOption = document.createElement('div');
			childOption.setAttribute('tabindex', 0);
			fontOption.className = 'option-name';
			fontOption.innerText = optionLabel + (defaultSize === settings[i].id ? defaultFontLabel : '');
			fontOption.style.fontSize = `${settings[i].size}px`;
			fontOption.style.lineHeight = `${settings[i].height}px`;
			fontOption.style.padding = `${settings[i].padding}`;
			options.setAttribute('data-selected', preferredFontSettings);
			childOption.setAttribute('data-id', settings[i].id);
			childOption.setAttribute('data-active', preferredFontSettings === settings[i].id);
			childOption.appendChild(avatar);
			childOption.appendChild(fontOption);
			childOption.addEventListener('click', onOptionClick);
			childOption.addEventListener('keydown', function (e) {
				const keyCode = e.which ? e.which : e.keyCode;
				const isTriggeredByEnter = keyCode === KEY_CODES.ENTER;
				if (isTriggeredByEnter) {
					onOptionClick.call(this, e, isTriggeredByEnter);
				}
			});
		}

		this.html.querySelector('.engt-font-settings-cta').appendChild(confirmBtn);
	}

	setter(propData) {
		this.data = {
			...this.data,
			...propData,
		};
	}

	render() {
		return this.html;
	}
}
